// extracted by mini-css-extract-plugin
export default {"cardsContainer":"performance_cardsContainer__NEVmH","chartContainer":"performance_chartContainer__0rKjG","slide-in-bottom":"performance_slide-in-bottom__kkYjS"};